import { useController, Validate } from "react-hook-form";
import SmoothCollapse from "react-smooth-collapse";

import { Checkbox, FieldError, Stack } from "@seneca/senekit";

type Props = {
  name: string;
  label: JSX.Element;
  checked?: boolean;
  disabled?: boolean;
  validateObj?: Validate<boolean> | Record<string, Validate<boolean>>;
};

export default function ControlledCheckbox(props: Props) {
  const { field, fieldState } = useController({
    name: props.name,
    defaultValue: props.checked || false,
    rules: { validate: props.validateObj }
  });

  return (
    <Stack space="small">
      <Checkbox
        disabled={props.disabled || false}
        name={props.name}
        onChange={field.onChange}
        checked={field.value}
      >
        <span>{props.label}</span>
      </Checkbox>

      <SmoothCollapse expanded={!!fieldState?.error?.message}>
        <FieldError>{fieldState?.error?.message}</FieldError>
      </SmoothCollapse>
    </Stack>
  );
}
